export default __webpack_public_path__ + "static/media/virtual_bg_small.79754bbf.jpg";